import React from "react";
import { useTranslation } from "react-i18next";
import { Radio, Stack } from "@mantine/core";

export const ANNUAL_INCOME_OPTIONS = [
  "< HKD 250,000",
  "HKD 250,000 - HKD 499,999",
  "HKD 500,000 - HKD 749,999",
  "HKD 750,000 - HKD 1,000,000",
  "> HKD 1,000,000",
];

const ClientAnnualIncome = ({ form: mainForm, disabled = false }) => {
  const { t } = useTranslation();

  return (
    <Radio.Group disabled={disabled} {...mainForm.getInputProps("annualIncome")}>
      <Stack spacing="xs">
        {ANNUAL_INCOME_OPTIONS.map((option) => (
          <Radio key={option} value={option} label={t(option)} />
        ))}
      </Stack>
    </Radio.Group>
  );
};

export default ClientAnnualIncome;
